import {NgModule} from '@angular/core';
import {SimpleTextFieldComponent} from './simple-text-field.component';

@NgModule({
              declarations: [SimpleTextFieldComponent],
              imports: [],
              exports: [SimpleTextFieldComponent]
          })
export class SimpleTextFieldModule { }